import React from 'react';
import './LooksCarousel.scss';

export type Ref = HTMLDivElement;

interface Props {
  children: React.ReactNode;
}

export const LooksCarousel = React.forwardRef<Ref, Props>(({ children }, ref) => (
  <div className="LooksCarousel" ref={ref}>
    {children}
  </div>
));
